// extracted by mini-css-extract-plugin
export default {"success":"Update_success__zqG3h","image":"Update_image__t8Rtu","btn":"Update_btn__X+9Zs","message":"Update_message__fNQWV","link":"Update_link__hng6n"};